import React, { Component } from 'react'
import { connect } from 'react-redux'
import {api} from "../../../../api";
import RaisedButton from 'material-ui/RaisedButton';
import * as SnackbarActions from "../../../../api/snackbar/actions";

class AppSettingsUserComponent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			settings: {
				columns: [
					{
						name: 'campaign',
						show: true,
					},
					{
						name: 'type',
						show: true,
					},
					{
						name: 'about',
						show: true,
					},
					{
						name: 'department',
						show: true,
					},
					{
						name: 'position',
						show: true,
					},
					{
						name: 'views',
						show: true,
					},
					{
						name: 'clicks',
						show: true,
					},
					{
						name: 'ctr',
						show: true,
					},
					{
						name: 'promotionIds',
						show: true,
					},
					{
						name: 'variantIds',
						show: true,
					},
				],
			},
			initialized: false
		};

		this.changeCheckbox = this.changeCheckbox.bind(this);
		this.saveSettings = this.saveSettings.bind(this);
		this.loadSettings = this.loadSettings.bind( this );
	}

	componentDidMount() {
		if ( undefined !== this.props.user.uid ) {
			this.loadSettings();
		}
	}

	componentDidUpdate() {
		if ( undefined !== this.props.user.uid && false === this.state.initialized ) {
			this.loadSettings();

			this.setState({
				initialized: true
			});
		}
	}

	loadSettings() {
		api.settings.user.getSettings(this.props.user.uid).then( async response => {
			if ( null !== response.val() ) {

				let settings = [];
				settings = response.val();

				await Promise.all(
					this.state.settings.columns.map( ( column, key ) => {
						if ( ! settings.columns[ key ] ) {
							settings = {
								...settings,
								columns: [
									...settings.columns,
									column
								]
							}
						}
					})
				);


				this.setState({
					settings: settings
				});
			}
		});
	}

	changeCheckbox( event ) {
		this.setState({
			settings: {
				...this.state.settings,
				columns: [
					...this.state.settings.columns.map( column => {

						if ( column.name === event.target.name ) {
							column.show = event.target.checked;
						}

						return column;
					})
				]
			}
		});
	}

	saveSettings() {
		api.settings.user.saveSettings(this.props.user.uid, this.state.settings).then( () => {
			api.snackbar.showMessage('De instellingen zijn opgeslagen');
		})
	}
	
	render() {
		// console.log( this.state.settings.columns );
		// console.log( this.props.user.uid );
		return (
			<div className="medium-12 cell">
				<div className="grid-x grid-container grid-padding-x">
					<div className="small-12 cell">
						<h2>Persoonlijke instellingen</h2>
						<p>Beheer hier je voorkeuren binnen CAMS</p>

						<h3>Statistieken weergave</h3>

						<div className="grid-x grid-padding-x">
							<fieldset className="large-12 cell">
								<legend>Selecteer de kolommen welke je weer wilt geven in het statistieken overzicht.</legend>
								<input id={'settings-campaign'} name={'campaign'} type="checkbox" onChange={this.changeCheckbox} checked={this.state.settings.columns[0].show} /><label htmlFor="settings-campaign">Campagne</label><br />
								<input id={'settings-type'} name={'type'} type="checkbox" onChange={this.changeCheckbox} checked={this.state.settings.columns[1].show} /><label htmlFor="settings-type">Type</label><br />
								<input id={'settings-about'} name={'about'} type="checkbox" onChange={this.changeCheckbox} checked={this.state.settings.columns[2].show} /><label htmlFor="settings-about">Waarover</label><br />
								<input id={'settings-department'} name={'department'} type="checkbox" onChange={this.changeCheckbox} checked={this.state.settings.columns[3].show} /><label htmlFor="settings-department">Opdrachtgever</label><br />
								<input id={'settings-position'} name={'position'} type="checkbox" onChange={this.changeCheckbox} checked={this.state.settings.columns[4].show} /><label htmlFor="settings-position">Positie</label><br />
								<input id={'settings-views'} name={'views'} type="checkbox" onChange={this.changeCheckbox} checked={this.state.settings.columns[5].show} /><label htmlFor="settings-views">Views</label><br />
								<input id={'settings-clicks'} name={'clicks'} type="checkbox" onChange={this.changeCheckbox} checked={this.state.settings.columns[6].show} /><label htmlFor="settings-clicks">Clicks</label><br />
								<input id={'settings-ctr'} name={'ctr'} type="checkbox" onChange={this.changeCheckbox} checked={this.state.settings.columns[7].show} /><label htmlFor="settings-ctr">CTR</label><br />
								<input id={'settings-promotionId'} name={'promotionIds'} type="checkbox" onChange={this.changeCheckbox} checked={this.state.settings.columns[8] ? this.state.settings.columns[8].show : true} /><label htmlFor="settings-ctr">Promotie ID</label><br />
								<input id={'settings-variantIds'} name={'variantIds'} type="checkbox" onChange={this.changeCheckbox} checked={this.state.settings.columns[9] ? this.state.settings.columns[9].show : true} /><label htmlFor="settings-ctr">Variant ID's</label><br />
							</fieldset>
						</div>
					</div>
				</div>
				<div className="settings--content--spacer"></div>
				<div className="grid-x grid-container grid-padding-y">
					<div className="small-12 cell text-right">
						<RaisedButton
							label="Instellingen Opslaan"
							primary={true}
							onClick={this.saveSettings}
							fullWidth={true}
						/>
					</div>
				</div>

			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		user: state.auth.user
	}
};

export default connect(mapStateToProps)(AppSettingsUserComponent)


// WEBPACK FOOTER //
// ./src/application/components/settings/user/index.js